import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import TableWithPagination from '../common/TableWithPagination';
import { usePermissions } from './../../hooks/usePermissions';


export default function Dashboard() {
  const [fecha, setFecha] = useState(new Date());
  const { hasPermission, hasRole, permissions = [], perfil, userData } = usePermissions();



  return (
    <div className="p-6 space-y-6">
      <label>Bienvenido</label>

      
    </div>
  );
}
